import React, { Component } from 'react';
import { withStyles, withTheme } from '@material-ui/core/styles';
import Select, { createFilter } from 'react-select';
import WindowedSelect from 'react-windowed-select';
import CreatableSelect from 'react-select/creatable';

var styles = (theme) => ({
    root: {
        height: 35,
        margin: '5px 0 12px', //This is confirmed to work in the filters, if this needs changing we need to take a look at this and work on it a bit more
        paddingTop: '2px',
        '&.multi': {
            height: 'auto',
            marginBottom: -2
        },
        '& .select > div:first-of-type': {
            minHeight: 35
        },
        '&.multi .select > div:first-of-type': {
            height: 'auto'
        },
        '& .select': {
            top: -15
        }
    },
    label: {
        backgroundColor: theme.light.primary,
        color: theme.light.text.primary + (theme.light.text.primary.includes('#') ? (theme.light.text.primary.length > 5 ? 'aa' : 'a') : ''),
        fontSize: '.75rem',
        padding: '2px 4px',
        marginLeft: '10px',
        position: 'relative',
        top: '-8px',
        zIndex: 2,
        [theme.darkTheme]: {
            backgroundColor: theme.dark.primary,
            color: theme.dark.text.primary
        },
        '& span': {
            fontSize: '.75rem',
            color: theme.light.text.primary + (theme.light.text.primary.includes('#') ? (theme.light.text.primary.length > 5 ? 'aa' : 'a') : ''),
            [theme.darkTheme]: {
                color: theme.dark.text.primary + (theme.dark.text.primary.includes('#') ? (theme.dark.text.primary.length > 5 ? 'aa' : 'a') : '')
            }
        }
    },
    labelError: {
        color: theme.light.text.errorTitle + theme.important,
        [theme.darkTheme]: {
            color: theme.dark.text.errorTitle + theme.important
        }
    },
    pError: {
        margin: '-5px 12px 0',
        fontSize: '0.75rem',
        lineHeight: '1em',
        letterSpacing: '0.03333em',
        color: theme.light.text.errorTitle,
        [theme.darkTheme]: {
            color: theme.dark.text.errorTitle
        }
    }
});

const customStyles = {
    menu: (provided, state) => ({
        ...provided,
        position: 'absolute'
    }),
    control: (provided, state) => ({
        ...provided,
        outline: 'none',
        height: '35px',
        width: '100%',
        backgroundColor: 'transparent'
    }),
    menuPortal: (provided, state) => ({
        ...provided,
        zIndex: '1400'
    })
};

const SELECT_ALL_OPTION = {
    label: 'Select ALL',
    value: 'ALL'
};

var colorSchemeWatch = window.matchMedia('(prefers-color-scheme: dark)');

class DrcSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            styleKey: '',
            styles: {}
        };

        this.matchMediaWatch = this.matchMediaWatch.bind(this);
        this.onLoad = this.onLoad.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    matchMediaWatch(e) {
        var isDarkTheme = e.matches;
        var isError = (this.props.helperText || '').length > 0;
        var styleKey = isDarkTheme.toString() + isError.toString();

        if (this.state.styleKey !== styleKey) {
            this.onLoad();
        }
    }

    onLoad() {
        var isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)').matches;
        var isError = (this.props.helperText || '').length > 0;
        var styleKey = isDarkTheme.toString() + isError.toString();

        if (this.state.styleKey !== styleKey) {
            const { theme } = this.props;

            var styles = {
                primary25: isDarkTheme ? theme.dark.accent.brightness(-10) : theme.light.accent.brightness(10),
                primary: isDarkTheme ? theme.dark.accent.primary : theme.light.accent.primary,
                neutral0: isDarkTheme ? theme.dark.primary : theme.light.primary, //option background
                neutral5: isDarkTheme ? theme.dark.variant.primary : theme.light.variant.primary, //Unknown
                neutral10: isDarkTheme ? theme.dark.secondary : theme.light.secondary, //multi-item-box
                neutral20: isError ? (isDarkTheme ? theme.dark.error : theme.light.error) : isDarkTheme ? theme.dark.buttonBorder : theme.light.buttonBorder, //Border
                neutral30: isError ? (isDarkTheme ? theme.dark.error : theme.light.error) : isDarkTheme ? theme.dark.text.primary : theme.light.text.primary, //Border Hover
                neutral80: isDarkTheme ? theme.dark.text.primary : theme.light.text.primary, //Text
                dangerLight: isDarkTheme ? theme.dark.buttonBorder : theme.light.buttonBorder, //multi-clear-btn
                danger: isDarkTheme ? theme.dark.text.primary : theme.light.text.primary //multi-clear-x
            };

            this.setState({ styleKey, styles });
        }
    }

    componentDidMount() {
        colorSchemeWatch.addListener(this.matchMediaWatch);
        this.onLoad();
    }

    componentDidUpdate() {
        this.onLoad();
    }

    componentWillUnmount() {
        colorSchemeWatch.removeListener(this.matchMediaWatch);
    }

    onChange(option, actionType) {
        if (this.props.filterChanged) {
            this.props.filterChanged({ value: option.value, label: option.label, type: this.props.name });
        }

        if (this.props.onChange) {
            if (this.props.selectAllAllowed) {
                if (option !== null && option.length > 0 && option[option.length - 1].label === SELECT_ALL_OPTION.label) {
                    this.props.onChange(this.props.options || this.props.children || [], actionType);
                } else {
                    this.props.onChange(option, actionType);
                }
            } else {
                this.props.onChange(option, actionType);
            }
        }
    }

    render() {
        const {
            className,
            children,
            options,
            label,
            onChange,
            value,
            selectStyle,
            helperText,
            hideLabel,
            classes,
            theme,
            isCreatable,
            isWindowedSelect,
            isMulti,
            required,
            ignoreAccents,
            closeMenuOnSelect,
            ...other
        } = this.props;

        var isError = (helperText || '').length > 0;
        var title = label || this.props.name;
        var name = this.props.name || label;

        var selectOptions = options || children || [];

        return (
            <div className={`${classes.root} ${isMulti ? 'multi' : ''} ${className || ''}`}>
                {!hideLabel ? (
                    <label className={`${classes.label} ${isError ? classes.labelError : ''}`} id={title + 'Lbl'}>
                        {required ? (
                            <span>
                                {title} <span className={classes.labelError}>*</span>
                            </span>
                        ) : (
                            title
                        )}
                    </label>
                ) : null}
                {!isCreatable ? (
                    isWindowedSelect ? (
                        <WindowedSelect
                            name={name}
                            aria-labelledby={title + 'Lbl'}
                            value={value}
                            onChange={this.onChange}
                            options={selectOptions}
                            className="select"
                            styles={customStyles}
                            menuPortalTarget={document.body}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    ...this.state.styles
                                }
                            })}
                            filterOption={createFilter({ ignoreAccents: false })}
                            isMulti={isMulti}
                            {...other}
                        />
                    ) : (
                        <Select
                            name={name}
                            aria-labelledby={title + 'Lbl'}
                            value={value}
                            onChange={this.onChange}
                            options={!!this.props.selectAllAllowed ? [SELECT_ALL_OPTION, ...selectOptions] : selectOptions}
                            className="select"
                            styles={customStyles}
                            menuPortalTarget={document.body}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    ...this.state.styles
                                }
                            })}
                            isMulti={isMulti}
                            closeMenuOnSelect={closeMenuOnSelect || !isMulti}
                            {...other}
                        />
                    )
                ) : (
                    <CreatableSelect
                        name={name}
                        aria-labelledby={title + 'Lbl'}
                        value={value}
                        onChange={this.onChange}
                        options={selectOptions}
                        className="select"
                        styles={customStyles}
                        menuPortalTarget={document.body}
                        theme={(theme) => ({
                            ...theme,
                            colors: {
                                ...theme.colors,
                                ...this.state.styles
                            }
                        })}
                        isMulti={isMulti}
                        {...other}
                    />
                )}
                {isError ? <p className={classes.pError}>{helperText}</p> : null}
            </div>
        );
    }
}

export default withTheme(withStyles(styles)(DrcSelect));
